import React, { useState, useEffect, useRef, Suspense } from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import ViewModal from "../../../product/ViewModal";
import useIsClient from "../../../../hooks/useIsClient";
import SvgCaretDown from "../../../../assets/icons/SvgCaretDown";
import Slider from "react-slick";
import ThreeDModal from "../../../product/3dModel";
import { Dialog, DialogTrigger } from "@/components/ui/dialog";

const QuickSlider = ({ images, onSale = false, selectedIndex }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [modalSlider, setModalSlider] = useState(null);
  let slider = useRef();
  const settings = {
    dots: false,
    speed: 500,
    infinite: false,
    arrows: false,
    slidesToScroll: 1,
    slidesToShow: 4.13,
    pauseOnHover: false,
    touchMove: true,
    vertical: true,
    verticalSwipping: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          vertical: false,
          draggable: true,
          swipe: true,
          swipeToSlide: true,
          slidesToShow: 4.5,
          verticalSwipping: false,
        },
      },
    ],
  };

  useEffect(() => {
    setModalSlider(slider);
  }, []);

  useEffect(() => {
    slider.slickGoTo(selectedIndex);
    setActiveIndex(selectedIndex);
  }, [selectedIndex]);

  const { isClient } = useIsClient();

  return (
    <Dialog>
      <div className="max-w-[100vw] flex flex-wrap w-full lg:w-1/2 pl-4 pr-5 gap-[10px] mt-0 box-border">
        <div className="relative max-w-[95vw] w-full md:w-1/5 order-[99] md:order-[0] products_images">
          <button
            className={`absolute w-[50px] h-[50px] shadow-lg bg-white rounded-full z-[4] justify-center items-center top-[-25px] left-[calc(50%-25px)]
            cursor-pointer hidden ${
              activeIndex === 0 ? "md:hidden" : "md:flex"
            }`}
            onClick={() => {
              slider.slickPrev();
              setActiveIndex(activeIndex - 1);
            }}
          >
            <SvgCaretDown style={{ transform: "rotate(180deg)" }} />
          </button>
          <Slider ref={(c) => (slider = c)} {...settings}>
            {images?.map((image, index) => (
              <div
                key={index}
                className="flex flex-col rounded-md w-full aspect-[200/240] lg:aspect-[200/260] pt-2 lg:pt-0 pb-2 px-2"
                onClick={() => {
                  slider.slickGoTo(index);
                  setActiveIndex(index);
                }}
              >
                {isClient &&
                  image.__typename === "ShopifyMediaImage" &&
                  image?.preview?.image?.gatsbyImageData && (
                    <div
                      className={`relative w-full h-full rounded-md box-border ${
                        activeIndex === index
                          ? "border-[3px] border-solid border-black"
                          : "border-none"
                      }`}
                    >
                      <GatsbyImage
                        image={image.preview.image.gatsbyImageData}
                        alt={image.preview.image.altText}
                        className="relative w-full h-full rounded-md object-cover"
                        objectFit="cover"
                        loading="lazy"
                      />
                    </div>
                  )}
                {isClient &&
                  image.__typename === "ShopifyExternalVideo" &&
                  image?.preview?.image?.gatsbyImageData && (
                    <div
                      className={`relative w-full h-full rounded-md box-border ${
                        activeIndex === index
                          ? "border-[3px] border-solid border-black"
                          : "border-none"
                      }`}
                    >
                      <GatsbyImage
                        image={image.preview.image.gatsbyImageData}
                        alt={image.preview.image.altText}
                        className="relative w-full h-full rounded-md object-cover"
                        objectFit="cover"
                        loading="lazy"
                      />
                      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white p-2 rounded-full flex items-center justify-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          className="w-6 h-6"
                        >
                          <path
                            fillRule="evenodd"
                            d="M4.5 5.653c0-1.426 1.529-2.33 2.779-1.643l11.54 6.348c1.295.712 1.295 2.573 0 3.285L7.28 19.991c-1.25.687-2.779-.217-2.779-1.643V5.653z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </div>
                    </div>
                  )}
                {isClient &&
                  image.__typename === "ShopifyModel3d" &&
                  image?.preview?.image?.gatsbyImageData && (
                    <div
                      className={`relative w-full h-full rounded-md box-border ${
                        activeIndex === index
                          ? "border-[3px] border-solid border-black"
                          : "border-none"
                      }`}
                    >
                      <GatsbyImage
                        image={image.preview.image.gatsbyImageData}
                        alt={image.preview.image.altText}
                        className="relative w-full h-full rounded-md object-cover"
                        objectFit="cover"
                        loading="lazy"
                      />
                      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white p-2 rounded-full">
                        <svg
                          className="icon icon-3d-model"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.22986 9.53394L11.9999 12.2969L16.7339 9.55194"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="square"
                          ></path>
                          <path
                            d="M12 17.1928V12.2878"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="square"
                          ></path>
                          <path
                            d="M10.8834 6.86131L8.00343 8.46331C7.35543 8.82331 6.81543 9.73231 6.81543 10.4793V13.5303C6.81543 14.2773 7.34643 15.1863 8.00343 15.5463L10.8834 17.1483C11.4954 17.4903 12.5034 17.4903 13.1244 17.1483L16.0044 15.5463C16.6524 15.1863 17.1924 14.2773 17.1924 13.5303V10.4703C17.1924 9.72331 16.6614 8.81431 16.0044 8.45431L13.1244 6.85231C12.5034 6.51031 11.4954 6.51031 10.8834 6.86131V6.86131Z"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="square"
                          ></path>
                          <path
                            d="M21.0015 14.7002C21.0015 18.1832 18.1845 21.0002 14.7015 21.0002L15.6465 19.4252"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="square"
                          ></path>
                          <path
                            d="M3 9.3C3 5.817 5.817 3 9.3 3L8.355 4.575"
                            stroke="currentColor"
                            strokeWidth="1.5"
                            strokeLinecap="square"
                          ></path>
                        </svg>
                      </div>
                    </div>
                  )}
              </div>
            ))}
          </Slider>
          <button
            className={`absolute w-[50px] h-[50px] shadow-lg bg-white rounded-full z-[4] justify-center items-center bottom-[-25px] left-[calc(50%-25px)]
            cursor-pointer hidden ${
              activeIndex === images?.length - 1 ? "md:hidden" : "md:flex"
            }`}
            onClick={() => {
              slider.slickNext();
              setActiveIndex(activeIndex + 1);
            }}
          >
            <SvgCaretDown />
          </button>
        </div>
        {images?.[activeIndex].__typename === "ShopifyMediaImage" && (
          <DialogTrigger asChild>
            <div className="relative w-full md:w-[77%] aspect-[4/5] cursor-pointer">
              <div className="flex flex-col rounded-xl w-full h-full cursor-pointer relative">
                {images?.[activeIndex] &&
                  images[activeIndex]?.preview?.image?.gatsbyImageData && (
                    <GatsbyImage
                      image={images[activeIndex]?.preview.image.gatsbyImageData}
                      alt={images[activeIndex]?.preview.image.altText}
                      className="relative w-full h-full rounded-xl object-cover cursor-pointer aspect-[576/770]"
                      loading="eager"
                    />
                  )}
              </div>
              {/* OnSale Label */}
              <button
                className={`absolute top-5 right-5 rounded-full shadow-md bg-white z-[11] py-[10px] px-[18px] font-medium leading-4 tracking-[0.4px] ${
                  onSale ? "block" : "hidden"
                }`}
              >
                On Sale
              </button>
              {/* Image Modal Icon */}
              <span
                className="absolute bottom-4 right-4 z-[1] w-[50px] h-[50px] flex items-center justify-center bg-white rounded-full"
                style={{
                  boxShadow: "0 0.2rem 1rem #0003",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="25"
                  fill="none"
                  className="w-[25px] h-[25px] text-black/30"
                  viewBox="0 0 24 25"
                >
                  <path
                    fill="currentColor"
                    d="M15.707 9.71l3.172-3.173L21 8.658V3.002h-5.656l2.121 2.121-3.172 3.172 1.414 1.414zm1.758 9.171l-2.121 2.121H21v-5.656l-2.121 2.121-3.172-3.172-1.414 1.414 3.172 3.172zm-9.172-4.586l-3.172 3.172L3 15.347v5.655h5.656l-2.121-2.12 3.172-3.173-1.414-1.414zM6.535 5.123l2.121-2.12H3v5.655l2.121-2.12 3.172 3.171 1.414-1.414-3.172-3.172z"
                  ></path>
                </svg>
              </span>
            </div>
          </DialogTrigger>
        )}
        {images?.[activeIndex].__typename === "ShopifyExternalVideo" && (
          <div className="relative w-full md:w-[77%] aspect-[4/5] cursor-pointer">
            <div className="flex flex-col rounded-xl w-full h-full cursor-pointer relative bg-black">
              <iframe
                src={
                  images[activeIndex]?.embeddedUrl.includes("watch?v=")
                    ? images[activeIndex]?.embeddedUrl.replace(
                        "watch?v=",
                        "embed/"
                      )
                    : images[activeIndex]?.embeddedUrl.replace(
                        "youtu.be/",
                        "youtube.com/embed/"
                      )
                }
                title="YouTube video player"
                loading="lazy"
                style={{ aspectRatio: "16/9" }}
                className="relative w-full my-auto object-contain cursor-pointer aspect-video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            {/* OnSale Label */}
            <button
              className={`absolute top-5 right-5 rounded-full shadow-md bg-white z-[11] py-[10px] px-[18px] font-medium leading-4 tracking-[0.4px] ${
                onSale ? "block" : "hidden"
              }`}
            >
              On Sale
            </button>
          </div>
        )}
        {images?.[activeIndex].__typename === "ShopifyModel3d" && (
          <div className="w-[95%] md:w-[77%] aspect-[576/739] cursor-grab">
            <div className="flex flex-col rounded-xl w-full aspect-[576/739] cursor-pointer relative">
              {images?.[activeIndex] && (
                <Suspense fallback={<div>Loading...</div>}>
                  <ThreeDModal
                    url={images?.[activeIndex].originalSource.url}
                    title={images?.[activeIndex].preview.image.altText}
                    imageUrl={images?.[activeIndex].preview.image.originalSrc}
                  />
                </Suspense>
              )}
            </div>
          </div>
        )}
      </div>
      {modalSlider && (
        <ViewModal
          modalSlider={modalSlider}
          images={images}
          activeIndex={activeIndex}
          setActiveIndex={setActiveIndex}
        />
      )}
    </Dialog>
  );
};

export default QuickSlider;
